export const DEFAULT_COLOR = '#5A81FA';
export const DEFAULT_PRINTER_COLOR = '#3DA28E';
